import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'gtlc-mobile-staff-device-token';

/**
 * Persists the per-tablet device secret returned once by POST /devices/register.
 * localStorage survives PWA reloads and matches the app's existing storage
 * pattern (MSAL cache also uses BrowserCacheLocation.LocalStorage).
 */
@Injectable({ providedIn: 'root' })
export class DeviceTokenService {
  readonly #token = signal<string | null>(this.readFromStorage());
  readonly token = this.#token.asReadonly();

  hasToken(): boolean {
    return this.#token() !== null;
  }

  setToken(token: string): void {
    localStorage.setItem(STORAGE_KEY, token);
    this.#token.set(token);
  }

  clearToken(): void {
    localStorage.removeItem(STORAGE_KEY);
    this.#token.set(null);
  }

  private readFromStorage(): string | null {
    return localStorage.getItem(STORAGE_KEY);
  }
}
